import {Component, OnInit, ViewChild} from '@angular/core';
import {DatatableService} from "../../../core/services/datatable.service";
import {DatagridComponent} from "../../../ui/datagrid/datagrid.component";
import { ActivatedRoute } from "@angular/router";
import {HttpClient} from "@angular/common/http";
import * as moment from 'moment';
import {EventService} from "../../../core/services/event.service";
import {ToastrService} from "ngx-toastr";
import { ProgressService } from '../../../core/services/progress.service';
import {Angulartics2} from "angulartics2";

@Component({
    selector: 'app-comments',
    templateUrl: './comments.component.html',
    styleUrls: ['./comments.component.scss']
})
export class CommentsComponent implements OnInit {
    @ViewChild('commentsTable', { static: true })
    datagrid: DatagridComponent;
    deleteBtn: any; // jQuery

    commentGridOptions: any = {
        data: [],
        columns: [
            {
                title: 'Date',
                type: 'date',
                data: 'commentCreatedDate',
                render: (x) => {
                    return moment.utc(x).format('MM/DD/YYYY');
                }
            },
            {
                title: 'Comment',
                data: 'comment'
            }
        ]
    };

    constructor(
        private datatableService: DatatableService,
        public eventService: EventService,
        private route: ActivatedRoute,
        private http: HttpClient,
        private ToastrService: ToastrService,
        private progressService: ProgressService,
        private angulartics2: Angulartics2
    ) {}

    ngOnInit() {
        const me = this;
        if (!this.eventService.selectedEvent.isPastEvent) {
            this.commentGridOptions.columns.unshift({
                type: 'checkbox',
                idProperty: 'commentID',
                class: 'text-center',
                data: 'checked',
                width: '10%'
            });
            this.commentGridOptions.addButtons = [{
              text: "Delete Selected",
              className: 'btn btn-primary btn-sm ui-create-post',
              action: function () {
                me.deleteSelected();
              },
              enabled: false,
              init: function ( dt, node, config ) { me.deleteBtn = node;}
            }];
            this.commentGridOptions.order = [[ 1, "desc" ]];
        }

        this.progressService.startProgress(false);
    }

    getData() {
        this.http.get('/api/v1/pages/' + this.route.snapshot.params['pageID'] + '/comments')
            .subscribe((comments: Array<any>) => {
                comments.forEach(o => {
                    o.checked = false;
                    this.datagrid.replaceData(comments);
                });
                this.progressService.stopProgress(false);
            });
    }

    deleteSelected() {
        let deletedComments = this.datatableService.deleteSelected(this.datagrid);
        let commentIds = deletedComments.map(o => {
            return o.commentID;
        });
        this.http.post('/api/v1/comments/?delete=', commentIds).subscribe(() => {
            this.ToastrService.success("Comment(s) deleted.");
            this.rowsSelected([]);
            this.angulartics2.eventTrack.next({
                action: 'Delete comment',
                properties: {category: 'Fundraising Pages: Comments'}
            });
        }, err => {
            this.ToastrService.error("Error happened during deletion.");
        });
    }

    rowsSelected($event) { // array of selected rows
      const selected = $event.length > 0;
      if (this.deleteBtn) { // event fires prior init completion
        if (selected) {
          this.deleteBtn.removeClass('disabled');
        } else {
          this.deleteBtn.addClass('disabled');
        }
      }
    }

}
